import React from 'react';

import {
  Image,
  Title,
  Description,
  LinkText,
  Button,
  Spinner
} from 'common/components';
import { Glossary, PlanListGL } from 'common/utils/glossary';

interface PlanProps {
  /** プラン画像のURL */
  imageSrc: string;
  /** プラン名 */
  planName: string;
  /** プランの説明 */
  planDescription: string;
  /** 詳細をみるをクリック時のコールバック関数 */
  onClickDetail: () => void;
  /** 購入するをクリック時のコールバック関数 */
  onClickPurchase: () => void;
  /** 購入開始処理実行中か否か */
  isProcessingPurchase: boolean;
  /** E2Eテスト用識別子 */
  'data-test': string;
  /** グロッサリ */
  glossary: Glossary;
}
type PlanInfoProps = Omit<PlanProps, 'imageSrc'>;

const PlanInfo: React.FC<PlanInfoProps> = ({
  planName,
  planDescription,
  onClickDetail,
  onClickPurchase,
  isProcessingPurchase,
  'data-test': dataTest,
  glossary
}) => {
  return (
    <div className="info" data-test={`${dataTest}`}>
      <Title type="name" data-test={`${dataTest}-title`}>
        {planName}
      </Title>
      <Description type="description" data-test={`${dataTest}-description`}>
        {planDescription}
      </Description>
      <LinkText
        type="detailLink"
        data-test={`${dataTest}-detailLink`}
        onClick={onClickDetail}
      >
        {glossary.glx(PlanListGL.Detail)} &gt;
      </LinkText>
      <Button
        type="nextButton"
        data-test={`${dataTest}-nextButton`}
        onClick={onClickPurchase}
      >
        {isProcessingPurchase ? (
          <Spinner type="button" width={22} height={22} />
        ) : (
          glossary.glx(PlanListGL.Purchase)
        )}
      </Button>
    </div>
  );
};

/**
 * 各プランのPresentation Component
 */
export const Plan: React.FC<PlanProps> = ({
  imageSrc,
  'data-test': dataTest,
  ...props
}) => {
  return (
    <div className="plan" data-test={dataTest}>
      <Image type="icon" imageSrc={imageSrc} data-test={`${dataTest}-image`} />
      <PlanInfo {...props} data-test={`${dataTest}-info`} />
    </div>
  );
};
